export class BlueStakesLog {
    id!: string
    indexId!: number
    job!: string
    address!: string
    orderedDate?: Date | string
    legalDate?: Date | string
    ticketUpdateDate?: Date | string
    ticketNumber!: string
    /** ISO-like time from API, e.g. `08:00:00` */
    requestTime?: string | null
    requesterHrRef?: number | null
    phoneNumber!: string
    isActive!: boolean
    notes!: string
    ticketOwnerHrRefs!: number[]
    documentUrls: string[] = []
    /** Parallel to documentUrls; original upload names from the server */
    documentFileNames: string[] = []
}
